export default {
  'PrioritiesSettings.ResetDefault': ({ }, outlet) => {
    outlet({ action: 'reset_default' })
  },
  'PrioritiesSettings.PrioritySetting': ({ value, setting }, outlet) => {
    outlet({ action: 'change', setting, newVal: value })
  },
  'PrioritiesSettings.HighPriority.Create': ({ priorities }, outlet) => {
    outlet({
      action: 'open_modal',
      priorities,
      priority: {
        id: null,
        name: '',
        assigned_orders: false,
        affects_orders: false,
        level: 'high',
        is_high_priority: true,
        color: 'red',
        icon: 'ExclamationMark',
        index: 0,
        is_default: false,
      },
    })
  },
  'PrioritiesSettings.HighPriorities': ({ value: { allPriorities, priority, action, priorities } }, outlet) => {
    if (action === 'edit') {
      outlet({
        action: 'open_modal',
        priorities: allPriorities,
        priority: {
          ...priority,
          level: 'high'
        },
      })
    }
    if (action === 'delete') {
      outlet({
        action: 'delete',
        priority,
      })
    }
    if (action === 'change_order') {
      outlet({ action: 'change_order', priority })
    }
  },
  'PrioritiesSettings.StandardPriorities': ({ value: { allPriorities, priority, action, priorities } }, outlet) => {
    if (action === 'edit') {
      outlet({
        action: 'open_modal',
        priorities: allPriorities,
        priority,
      })
    }
    if (action === 'delete') {
      outlet({
        action: 'delete',
        priority: {
          ...priority,
          level: 'low'
        },
      })
    }
    if (action === 'change_order') {
      outlet({ action: 'change_order', priority })
    }
  },
  'PrioritiesSettings.StandardPriority.Create': ({ priorities }, outlet) => {
    outlet({
      action: 'open_modal',
      priorities,
      priority: {
        id: null,
        name: '',
        assigned_orders: false,
        affects_orders: false,
        level: 'standard',
        is_high_priority: false,
        color: 'green',
        icon: 'CheckMark',
        index: 0,
        is_default: false,
      },
    })
  },
}